import React, { createContext, useContext, useRef } from "react";

interface BroadcastContextProps {
  channel: React.MutableRefObject<BroadcastChannel>;
}

const BroadcastContext = createContext<BroadcastContextProps>(
  {} as BroadcastContextProps,
);

export const BroadcastProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const channel = useRef<BroadcastChannel>(
    new BroadcastChannel("SIGNALR_BROADCAST_CHANNEL"),
  );

  return (
    <BroadcastContext.Provider value={{ channel }}>
      {children}
    </BroadcastContext.Provider>
  );
};

export function useBroadcast(): BroadcastContextProps {
  const context = useContext(BroadcastContext);

  if (!context) {
    throw new Error("useBroadcast must be used within a BroadcastProvider");
  }
  return context;
}
